'use client';

import { c as _c } from "react/compiler-runtime";
import type { CartItemAccommodationFragment, CartItemExperienceFragment } from '@data-access/lib/gql/cart/documents';
import type { Cart } from '@feat/feat-cart/cart';
import { shopTestId } from '@utils/utils-shop-test-ids';
import dynamic from 'next/dynamic';
import { useState } from 'react';
import { AppCartItemAccommodationModal } from './app-cart-item-accommodation-modal';
import { AppCartItemExperienceModal } from './app-cart-item-experience-modal';
import { SkeletonCartItem } from './cart-item/skeleton-cart-item';
const CartItem = dynamic(() => import('@feat/feat-cart/cart-item').then(mod => ({
  default: mod.CartItem
})), {
  loading: () => <SkeletonCartItem />
});
export type AppCartListProps = {
  cart: Cart;
  showSeparator?: boolean;
};
export function AppCartList(t0) {
  const $ = _c(19);
  const {
    cart,
    showSeparator: t1
  } = t0;
  const showSeparator = t1 === undefined ? true : t1;
  const [experienceItem, setExperienceItem] = useState(null);
  const [accommodationItem, setAccommodationItem] = useState(null);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = shopTestId("CartList.list");
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== cart.items.all || $[2] !== showSeparator) {
    let t4;
    if ($[4] !== cart.items.all.length || $[5] !== showSeparator) {
      t4 = (item, index) => <li key={item.id}><CartItem item={item} onEditExperience={setExperienceItem} onEditAccommodation={setAccommodationItem} showSeparator={index !== cart.items.all.length - 1 && showSeparator} /></li>;
      $[4] = cart.items.all.length;
      $[5] = showSeparator;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    t3 = cart.items.all.map(t4);
    $[1] = cart.items.all;
    $[2] = showSeparator;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <ul data-testid={t2} className="flex flex-col gap-6 sm:gap-0">{t3}</ul>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setExperienceItem(null);
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== experienceItem) {
    t6 = <AppCartItemExperienceModal item={experienceItem} onClose={t5} />;
    $[10] = experienceItem;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => setAccommodationItem(null);
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== accommodationItem) {
    t8 = <AppCartItemAccommodationModal item={accommodationItem} onClose={t7} />;
    $[13] = accommodationItem;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t4 || $[16] !== t6 || $[17] !== t8) {
    t9 = <>{t4}{t6}{t8}</>;
    $[15] = t4;
    $[16] = t6;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return t9;
}